<template>
    <div><!-- COA&CAR&JQM審核總表 -->
        <CCard class="w-100">
            <CCardHeader>
                <strong>COA&CAR&JQM審核總表</strong>
            </CCardHeader>
            <CCardBody>                
                    <CForm>
                        <div class="CForminline">
                            <div class="factory">
                                <p>&emsp;&emsp;{{$t('QuoteInfo_Vue.FactoryType')}}：</p>
                                    <div v-for="(item, key) in factoryList" :key="'factoryType_input_' + key">
                                       <input :disabled ="disableFactory" type="radio" :name="'generalTable_FactoryTypeOpt'" v-model="generalTableQueryParam.factoryId" :value="item.factoryId" >{{getFactoryCaption(item.factoryId,item.factoryCaption)}}
                                    </div>
                            </div>
                            <div class="factory">
                                    <p>{{$t('QualityInfo_Vue.CustomerName')}}：</p>
                                    <input style="width: 500px;" type="text" v-if="disableCusName_input" :disabled="true" v-model="generalTableQueryParam.customerName">                                                        
                                    <Select2 style="width: 500px;" v-if="!disableCusName_input" v-model="generalTableQueryParam.vendorId" :options="memberListFilter()" :settings="{  multiple: false, dropdownAutoWidth : true , width: '100%' ,allowClear:true}" />                                    
                            </div>
                            <div class="date">
                                <p>{{$t('QualityInfo_Vue.CreateDatePeriod')}}：</p>
                                    <date-picker :lang="lang" format="YYYY-MM-DD" valueType="format" v-model="generalTableQueryParam.createDateBegin"></date-picker> 
                                    <span>~</span>
                                    <date-picker :lang="lang" format="YYYY-MM-DD" valueType="format" v-model="generalTableQueryParam.createDateEnd"></date-picker>
                            </div>
                            <div class="btn_group">                                
                                <button type="button" class="btn btn-edit mr-2" @click="generalTableQueryEvent">{{$t('Buttons.Query')}}</button>
                                <button type="button" class="btn btn-success" @click="generalTableExportEvent">{{$t('Buttons.ExportOrder')}}</button>
                            </div>                            
                        </div>
                    </CForm>
            </CCardBody>
        </CCard>
        <CCard>
            <CCardBody>
                <table class="table ">
                    <thead class="thead-light">
                        <tr>
                            <th class="text-center">{{headers[0]}}</th>
                            <th class="text-center">{{headers[1]}}</th>
                            <th class="text-center">{{headers[2]}}</th>
                            <th class="text-center">{{headers[3]}}</th>
                            <th class="text-center">{{headers[4]}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item , index) in generalTableSearchResult" :key="index">                        
                            <td class="text-center">{{item.factoryName}}</td>
                            <td class="text-center">{{item.customerName}}</td>
                            <td class="text-center">
                                <router-link @click.native="viewEvent('coa' , item)" to="">{{item.coaCaseText}}</router-link>
                            </td>
                            <td class="text-center">
                                <router-link @click.native="viewEvent('car', item)" to="">{{item.carCaseText}}</router-link>
                            </td>
                            <td class="text-center">
                                <router-link @click.native="viewEvent('jqm', item)" to="">{{item.jqmCaseText}}</router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </CCardBody>
        </CCard>
    </div>
</template>
<script>
import { qualityMixin } from '@/mixin/quality'
import { mapGetters } from 'vuex'
export default {
    mixins: [qualityMixin],	
    data() {
        return {      
            headers :[
                this.i18n("Generaltable.Factory"),this.i18n("Generaltable.Vendor"),"COA","Issue(CAR)","JQM"
            ],      
            factoryList: this.$t('factoryQMList'), //廠別 清單
            generalTableQueryParam: {
                hadQuery : false,
                customerName : '',
                createDateBegin :null,
                createDateEnd :null,
                factoryId : ''
            },
            generalTableSearchResult : []
        }
    },
    props : {
    },
    watch: {
        "lang": function() {
            this.headers = [
                this.i18n("Generaltable.Factory"),this.i18n("Generaltable.Vendor"),"COA","Issue(CAR)","JQM"
            ]
        }
    },
    methods: {
        generalTableQueryEvent (){
            this.generalTableQueryParam.hadQuery = true;
            this.doGeneralTableSearch (this.generalTableQueryParam);         
        },
        doGeneralTableSearch (param){
            const url = `${this.$apiUrl_Quality}/SearchGeneralTable`;
            this.updateLoading(true);
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                    
                    //--成功          
                    this.generalTableSearchResult = response.data;
                    this.setCacheQueryParam('GeneralTable_QueryParam' , param);                           
                }                    
            }); 
        },        
        generalTableExportEvent (){//匯出
            this.doGeneralTableExport(this.generalTableQueryParam)
        },
        doGeneralTableExport(param){
            const url = `${this.$apiUrl_Quality}/PrepareSearchGeneralTableExport`;
            this.axios.post(url, param).then((response) => {                        
                const respObj = response.data;                 
                const exportExcelToken = respObj.token;
                let urlExcel = `${this.$apiUrl_Quality}/SearchGeneralTableExportExcel/${exportExcelToken}`;
                this.openNewTabByALink('GeneralTableExportExcel',urlExcel);
            })
        },
        viewEvent (type ,item){            
            sessionStorage.setItem('gtLinkType', type);
            sessionStorage.setItem('gtLinkVendor', item.vendor);
            this.$router.push('generaltable_information');
        },
        i18n (keyStr){
            return this.$t(keyStr);
        },
    },
    computed: {    
        ...mapGetters(["lang"]),    
    },
	mounted() {
        this.getCacheQueryParam('GeneralTable_QueryParam' , this.generalTableQueryParam);        
        const userFactoryId= this.userFactoryId;
        if(userFactoryId){
            this.generalTableQueryParam.factoryId = userFactoryId;
        }         
        if(this.isMember){
            const userInfo = this.$userInfo ;
            this.generalTableQueryParam.vendorId = userInfo.vendorId;
            this.generalTableQueryParam.customerName = userInfo.companyName;

        }else{
            this.initMemberQMList();
        }
        if(this.generalTableQueryParam.hadQuery){
            this.generalTableQueryEvent ();
        }
	},
    created() {        
    }
}	
</script>
<style lang="scss" scoped>
.CForminline {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    > .form-group {
        margin-bottom: 0;
    }

    > .name, .factory, .supplier, .watch, .check, .status, .date {
        display: flex;
        align-items: center;
        margin: .5rem 0;
        // width: 350px;

        > p {
            margin-right: 1rem;
            margin-bottom: 0;
        }
        > .purchase_input {
            margin-bottom: 0;
        }
        > input {
            flex: 1;
            margin: 0 .5rem;
        }
            > div {
                margin: 0 .5rem;
            }        
    }
}

.purchase {
    width: 100%;
}

.btn-edit {
    background-color: #343b55;
    color: white;
}

table th:first-child {
    text-align: center;
    padding: 15px 5px;
}

.table th {
    background-color: #303c50;
    color: #fff;
}

.table tr:nth-child(even) {
    background-color: transparent;
}
.table tr.table-close {
    background-color: #D0D0D0;
}
</style>




